(function () {
  const section = document.querySelector("[data-product-section]");
  if (!section) return;

  const variants = JSON.parse(section.querySelector("[data-product-variants]").textContent || "[]");
  const product = JSON.parse(section.querySelector("[data-product-json]").textContent || "{}");
  const variantInput = section.querySelector("[data-variant-id]");
  const priceEl = section.querySelector("[data-price]");
  const compareEl = section.querySelector("[data-compare]");
  const saveEl = section.querySelector("[data-save]");
  const addBtn = section.querySelector("[data-add-to-cart]");
  const addText = section.querySelector("[data-add-text]");
  const mainImage = section.querySelector("[data-main-image]");
  const form = section.querySelector("[data-product-form]");

  function syncStickyOffset() {
    const announcement = document.querySelector(".announcement-marquee, [data-announcement]");
    const header = document.querySelector("[data-header], .site-header");
    let offset = 12;
    if (announcement) offset += announcement.getBoundingClientRect().height;
    if (header) offset += header.getBoundingClientRect().height;
    document.documentElement.style.setProperty("--product-sticky-top", Math.ceil(offset) + "px");
    document.documentElement.style.setProperty("--header-offset", Math.ceil(offset) + "px");
  }
  syncStickyOffset();
  window.addEventListener("resize", syncStickyOffset);
  window.addEventListener("load", syncStickyOffset);

  function money(cents) {
    return window.MyStoreCart ? window.MyStoreCart.formatMoney(cents) : "Rs. " + (cents / 100).toFixed(2);
  }

  function currentVariant() {
    const checked = section.querySelector("[data-variant-radio]:checked");
    if (checked) {
      const id = Number(checked.value);
      const fromRadio = variants.find(function (v) { return v.id === id; });
      if (fromRadio) {
        if (variantInput) variantInput.value = fromRadio.id;
        return fromRadio;
      }
    }
    const id = Number(variantInput.value);
    return variants.find(function (v) { return v.id === id; }) || variants.find(function (v) { return v.available; }) || variants[0];
  }

  function setCodAvailability(variant) {
    document.querySelectorAll("[data-cod-open]").forEach(function (btn) {
      btn.disabled = !variant || !variant.available;
    });
  }

  function selectVariant(variant) {
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    const compare = variant.compare_at_price;
    if (compareEl) {
      if (compare > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = money(compare);
      } else {
        compareEl.hidden = true;
      }
    }
    if (saveEl) {
      if (compare > variant.price) {
        const pct = Math.round(((compare - variant.price) / compare) * 100);
        saveEl.hidden = false;
        saveEl.textContent = "SAVE " + pct + "%";
      } else {
        saveEl.hidden = true;
      }
    }
    if (addBtn) addBtn.disabled = !variant.available;
    if (addText) addText.textContent = variant.available ? "PAY ONLINE & GET ₹100 OFF" : "SOLD OUT";
    const buyNow = section.querySelector("[data-buy-now]");
    if (buyNow) buyNow.disabled = !variant.available;
    setCodAvailability(variant);
    if (variant.featured_image && mainImage) mainImage.src = variant.featured_image;
    document.querySelectorAll(".bundle-option").forEach(function (el) {
      const input = el.querySelector("[data-variant-radio]");
      const isMatch = input && Number(input.value) === variant.id;
      el.classList.toggle("is-selected", isMatch);
      if (input) input.checked = isMatch;
    });
    syncCodPopup(variant);
  }

  section.addEventListener("change", function (e) {
    const radio = e.target.closest("[data-variant-radio]");
    if (radio) {
      const variant = variants.find(function (v) { return v.id === Number(radio.value); });
      selectVariant(variant);
      return;
    }
    const select = e.target.closest("[data-variant-select]");
    if (select) {
      const variant = variants.find(function (v) { return v.id === Number(select.value); });
      selectVariant(variant);
    }
  });

  section.querySelectorAll("[data-thumb]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      section.querySelectorAll("[data-thumb]").forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      if (mainImage) mainImage.src = btn.dataset.src;
    });
  });

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const variant = currentVariant();
      if (!variant || !variant.available) return;
      const addBtnEl = document.querySelector("[data-add-to-cart]");
      const addTextEl = document.querySelector("[data-add-text]");
      if (!window.MyStoreCart) {
        form.submit();
        return;
      }
      const original = addTextEl ? addTextEl.textContent : "ADD TO CART";
      if (addBtnEl) addBtnEl.disabled = true;
      if (addTextEl) addTextEl.textContent = "ADDING...";
      window.MyStoreCart.addToCart(variant.id, 1)
        .then(window.MyStoreCart.fetchCart)
        .then(function (cart) {
          window.MyStoreCart.updateCartCount(cart);
          window.MyStoreCart.renderDrawer(cart);
          if (window.theme && window.theme.cartDrawer) window.MyStoreCart.openDrawer();
          if (addTextEl) addTextEl.textContent = "ADDED ✓";
          setTimeout(function () {
            if (addTextEl) addTextEl.textContent = original;
            if (addBtnEl) addBtnEl.disabled = !currentVariant().available;
          }, 1200);
        })
        .catch(function (err) {
          alert(err.message || "Could not add to cart");
          if (addTextEl) addTextEl.textContent = original;
          if (addBtnEl) addBtnEl.disabled = !currentVariant().available;
        });
    });
  }

  const buyNowBtn = section.querySelector("[data-buy-now]");
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", function () {
      const variant = currentVariant();
      if (!variant || !variant.available) return;
      if (!window.MyStoreCart) {
        window.location.href = "/cart/" + variant.id + ":1";
        return;
      }
      buyNowBtn.disabled = true;
      window.MyStoreCart.addToCart(variant.id, 1)
        .then(function () {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.checkout) || "/checkout";
        })
        .catch(function (err) {
          alert(err.message || "Could not proceed to checkout");
          buyNowBtn.disabled = !currentVariant().available;
        });
    });
  }

  function nice(date) {
    const d = date.getDate();
    const suf = (d % 10 === 1 && d !== 11) ? "st" : (d % 10 === 2 && d !== 12) ? "nd" : (d % 10 === 3 && d !== 13) ? "rd" : "th";
    return date.toLocaleDateString("en-US", { month: "short" }) + " " + d + suf;
  }

  const ordered = document.querySelector("[data-date-ordered]");
  const ready = document.querySelector("[data-date-ready]");
  const delivered = document.querySelector("[data-date-delivered]");
  if (ordered) {
    const now = new Date();
    const d2 = new Date(now); d2.setDate(now.getDate() + 1);
    const d4 = new Date(now); d4.setDate(now.getDate() + 3);
    const d5 = new Date(now); d5.setDate(now.getDate() + 4);
    ordered.textContent = nice(now);
    if (ready) ready.textContent = nice(d2) + "-" + nice(d4).replace(/^[A-Za-z]+ /, "");
    if (delivered) delivered.textContent = nice(d2) + "-" + nice(d5).replace(/^[A-Za-z]+ /, "");
  }

  const modal = document.querySelector("[data-cod-modal]");

  function syncCodPopup(variant) {
    if (!modal || !variant) return;
    const img = mainImage ? mainImage.src : "";
    modal.querySelector("[data-cod-image]").src = img;
    modal.querySelector("[data-cod-title]").textContent = product.title || "";
    modal.querySelector("[data-cod-variant]").textContent = variant.title || "";
    const price = money(variant.price);
    modal.querySelector("[data-cod-price]").textContent = price;
    modal.querySelector("[data-cod-subtotal]").textContent = price;
    modal.querySelector("[data-cod-total]").textContent = price;
    modal.querySelector("[data-cod-cta-price]").textContent = price;
  }

  function openCod() {
    const variant = currentVariant();
    if (!variant || !variant.available) {
      alert("This option is currently sold out. Please choose another pack or check back later.");
      return;
    }
    syncCodPopup(variant);
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeCod() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  document.querySelectorAll("[data-cod-open]").forEach(function (btn) {
    btn.addEventListener("click", openCod);
  });
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target.closest("[data-cod-close]")) closeCod();
    });
    const codForm = modal.querySelector("[data-cod-form]");
    codForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      const variant = currentVariant();
      if (!variant || !variant.available) {
        alert("This option is currently sold out. Please choose another pack or check back later.");
        return;
      }
      const data = new FormData(codForm);
      const attrs = {
        checkout_method: "Cash on Delivery requested",
        first_name: data.get("first_name"),
        last_name: data.get("last_name"),
        phone: data.get("phone"),
        address: data.get("address1"),
        landmark: data.get("landmark"),
        pincode: data.get("zip"),
        state: data.get("province"),
        city: data.get("city"),
        email: data.get("email") || ""
      };
      const note = [
        "COD order from product page",
        "Name: " + attrs.first_name + " " + attrs.last_name,
        "Phone: " + attrs.phone,
        "Address: " + attrs.address,
        "Landmark: " + attrs.landmark,
        "City: " + attrs.city,
        "State: " + attrs.state,
        "Pincode: " + attrs.pincode,
        "Email: " + attrs.email
      ].join(" | ");

      const submitBtn = modal.querySelector("[data-cod-submit]");
      const originalLabel = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = "Processing...";
      try {
        if (!window.MyStoreCart) {
          throw new Error("Cart is not ready. Please refresh the page and try again.");
        }
        await window.MyStoreCart.clearCart();
        await window.MyStoreCart.addToCart(variant.id, 1, {
          Pack: variant.title,
          Landmark: attrs.landmark
        });
        await window.MyStoreCart.updateCart({
          note: note,
          attributes: attrs
        });
        window.location.href = (window.theme && window.theme.routes && window.theme.routes.checkout) || "/checkout";
      } catch (err) {
        const message = (err && err.message) || "Could not start checkout. Please try again.";
        if (/sold out/i.test(message)) {
          alert(message + "\n\nTip: In Shopify Admin, open this product and check inventory quantity or enable 'Continue selling when out of stock'.");
        } else {
          alert(message);
        }
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalLabel;
      }
    });
  }

  selectVariant(currentVariant());
})();
